let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9mbK9")).then(() => parcelRequire('aBEEJ'));